import styled from 'styled-components';
import { ProgressLabelLayoutProps } from './progressBar.types';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const Message = styled.div`
  color: ${({ theme }) => theme.ui2};
  font-family: ${({ theme }) => theme.font.t1.fontFamily};
  font-weight: ${({ theme }) => theme.font.t1.fontWeight};
  font-size: ${({ theme }) => theme.font.t1.fontSize};
  margin-bottom: 20px;
`;
export const ProgressInfoContainer = styled.div`
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: end;
`;
export const ProgressLabel = styled.div<ProgressLabelLayoutProps>`
  color: red ${(props) => (props.statusColor ? props.statusColor : props.theme.color.s1)};
  font-family: ${({ theme }) => theme.font.t4.fontFamily};
  font-weight: ${({ theme }) => theme.font.t4.fontWeight};
  font-size: ${({ theme }) => theme.font.t4.fontSize};
`;
export const ProgressLabelContainer = styled.div`
  display: flex;
  gap: 0 2px;
`;
